exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".online-mcq-admin-qn-img-box p img {\n    display: block;\n      margin: 5px 0;\n      max-width: 100%;\n  }\n  .admin-quiz-qn-img-box p img {\n    /*max-width: 100px;*/\n    margin: 5px 0;\n      display: block;\n  }\n  .admin-quiz-qn-img-box p {\n    margin: 0;\n  }\n  .admin-quiz-qn-img-box .correctoption .solutioncontent-box img {\n    width: 100px;\n}\n  .QUESTION-ANALYTICS-list-box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n  .QUESTION-ANALYTICS-list-box div {\n  -webkit-box-flex: 1;\n    -ms-flex: auto;\n    flex: auto;\n    border-bottom: 1px dotted #d8d8d8!important;\n    padding: 0 0 8px 0!important;\n    margin: 5px 0 5px 0!important;\n    border-right: 1px dotted #d8d8d8!important;\n    text-align: center;\n}\n  .QUESTION-ANALYTICS-list-box div:first-child {\n  border-left: 1px dotted #d8d8d8!important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/online-mcq/solutionreport/solutionreport.component.css
// module id = ../../../../../src/app/online-mcq/solutionreport/solutionreport.component.css
// module chunks = common